// biome-ignore-all lint/a11y: TODO - address a11y issues later
import { Copy } from "lucide-react";
import * as React from "react";
import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

export interface SystemIdProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  showCopy?: boolean;
  truncate?: boolean;
  maxLength?: number;
}

export function SystemId({
  id,
  showCopy = false,
  truncate = false,
  maxLength = 8,
  className,
  ...props
}: SystemIdProps) {
  const [copied, setCopied] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const displayId =
    truncate && id.length > maxLength ? `${id.substring(0, maxLength)}...` : id;

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    setCopied(true);
    setOpen(true);

    // Close tooltip after delay
    setTimeout(() => {
      setCopied(false);
      setOpen(false);
    }, 1500);
  };

  // Prevent showing tooltip on hover
  const handleTooltipOpenChange = (isOpen: boolean) => {
    if (isOpen && !copied) {
      return; // Don't open if not copied
    }
    setOpen(isOpen);
  };

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={handleTooltipOpenChange}>
        <TooltipTrigger asChild>
          <div
            className={cn(
              "inline-flex items-center gap-1 text-[0.65rem] font-mono text-muted-foreground hover:text-accent-foreground bg-muted hover:bg-accent px-1 py-0.2 rounded-sm cursor-pointer",
              className,
            )}
            onClick={handleCopy}
            {...props}
          >
            <span>{displayId}</span>
            {showCopy && <Copy size={10} />}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copied!</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
